import { render } from "./BrokerSftpConfigurationCard.vue?vue&type=template&id=d2bbb2d0&scoped=true&ts=true"
import script from "./BrokerSftpConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./BrokerSftpConfigurationCard.vue?vue&type=script&lang=ts"

import "./BrokerSftpConfigurationCard.vue?vue&type=style&index=0&id=d2bbb2d0&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2bbb2d0"]])

export default __exports__